import React, { Component, Fragment } from "react";
import HeaderBanner from "../../components/header-banner";
import nl2br from "react-nl2br";
import { PAGES, PAGE_VIDEOS } from "../../constants/constants";
import axios from "axios";
import { gaPageview } from "../../utils/dev";

export default class VideoPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videos: null,
      isLoading: false
    };

    this.loadVideos = this.loadVideos.bind(this);
  }

  componentDidMount() {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    gaPageview(this.props.location);

    this.loadVideos();
  }

  loadVideos() {
    this.setState({ isLoading: true }, async () => {
      await axios.get("/resources/type/Videos").then(res => {
        this.setState({ videos: res.data, isLoading: false });
      });
    });
  }

  render() {
    const page = PAGES["videos"];
    const { videos } = this.state;

    let mapVideos = [];

    if (videos !== null) {
      mapVideos = videos.map(video => (
        <div
          className="video-frame space-small-bottom"
          style={{ width: "80%", margin: "0 auto" }}
        >
          <object
            style={{ width: "100%", minHeight: "480px" }}
            aria-label={video.title}
            data={video.description}
          >
            {video.title}
          </object>
        </div>
      ));
    }

    const pageDescription = (
      <p className="space-small-bottom">{nl2br(PAGE_VIDEOS.description)}</p>
    );
    return (
      <Fragment>
        {HeaderBanner(page.bannerTitle, page.bannerImage)}
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="resources-title space-top text-left">
                {pageDescription}
              </div>
              <hr />
            </div>
            <div className="col-12 space-small-bottom space-small-top text-center">
              {mapVideos}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
